export default {
  init($element) {

  },
  finalize($element) {
    $element.find('.accordion-item').each(function() {
      $(this).find('.item-header').on('click', function() {
        if (!$(this).parent().hasClass('open')) {
          // Close all others and open this one
          $element.find('.accordion-item.open .item-answer-wrap').stop().slideUp(200);
          $element.find('.accordion-item.open').removeClass('open');
          $(this).parent().addClass('open');
          $(this).siblings('.item-answer-wrap').stop().slideDown(200);
        } else {
          // Just close this one
          $(this).parent().removeClass('open');
          $(this).siblings('.item-answer-wrap').stop().slideUp(200);
        }
      });
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/flexible/frequentlyAskedQuestions.js